var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "invoice-report",
      attrs: { "aria-label": _vm.$t("invoices.reports.heading") }
    },
    [
      _c(
        "dl",
        { staticClass: "metric-grid" },
        _vm._l(_vm.reportMetrics, function(metric) {
          return _c(
            "div",
            {
              key: metric.key,
              staticClass: "metric-card",
              class: { "is-deposit": metric.deposit }
            },
            [
              _c("div", { staticClass: "metric-heading" }, [
                _c("dt", [_vm._v(_vm._s(metric.label))]),
                _c(
                  "span",
                  {
                    staticClass: "metric-icon",
                    attrs: { "aria-hidden": "true" }
                  },
                  [
                    _c("portal-icon", {
                      attrs: { name: metric.icon, size: 19 }
                    })
                  ],
                  1
                )
              ]),
              _c("dd", [_vm._v(_vm._s(metric.value))])
            ]
          )
        }),
        0
      ),
      _c("div", { staticClass: "report-chart-grid" }, [
        _c(
          "section",
          { staticClass: "report-chart-card report-chart-card-wide" },
          [
            _c("header", { staticClass: "report-chart-heading" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("invoices.reports.monthly-invoiced")))
              ])
            ]),
            _c("invoice-by-month", { attrs: { invoices: _vm.invoices } })
          ],
          1
        ),
        _c(
          "section",
          { staticClass: "report-chart-card" },
          [
            _c("header", { staticClass: "report-chart-heading" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("invoices.reports.spend-by-project")))
              ])
            ]),
            _c("spend-by-project", {
              attrs: { invoices: _vm.invoices, projects: _vm.projects }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }